import { Fragment, useEffect } from 'react';
import { Breakpoints, useBreakpoint } from '@nextgen-web-framework/all';
import ContentCard, { VariantEnum } from '../ContentCard/ContentCard';
import ContentLoader from '../ContentCard/CardLoader/CardLoader';
import { ContentCardResultsProps } from './types/propTypes';
import styles from './ContentCardResults.module.scss';

const ContentCardResults = ({
  sectionTitle,
  cards,
  loading,
  className,
  mode,
  loadingItems = 3,
  setLastCard,
}: ContentCardResultsProps) => {
  const viewport = useBreakpoint() as Breakpoints;
  const loaderItems = [...Array(loadingItems)].map((_, index) => index);
  const lastImageChildSelector = `.content-card-${mode} .content-image:last-child`;
  const noImageSelector = `.content-card-${mode} .no-image-container`;
  useEffect(() => {
    const lastCard = document.querySelector<HTMLLIElement>('.content-card:last-child');
    if (lastCard && setLastCard) {
      setLastCard(lastCard);
    }
    setTimeout(() => {
      const imageHeight = document.querySelector<HTMLCanvasElement>(lastImageChildSelector)?.height || 190;
      const noImageDivs = document.querySelectorAll<HTMLCanvasElement>(noImageSelector) || [];
      if (imageHeight) {
        noImageDivs.forEach((noImageDiv: HTMLElement) => {
          noImageDiv.style.height = `${imageHeight}px`;
        });
      }
    }, 100);
  }, [cards]);

  return (
    <div className={`${styles['content-card-results']} ${className} content-card-${mode}`}>
      <div className={styles['section-header']}>
        <div
          className={`${styles['section-title']} ${
            ![Breakpoints.XS, Breakpoints.SM].includes(viewport) && styles['font-h4']
          }`}
        >
          {sectionTitle}
        </div>
      </div>

      <div className={styles['card-items']}>
        {cards.map((item) => (
          <Fragment key={item.title}>
            <ContentCard {...item} mode={mode} />
          </Fragment>
        ))}
        {loading &&
          loaderItems.map((i) => (
            <Fragment key={i}>
              <ContentLoader variant={VariantEnum.SRP} />
            </Fragment>
          ))}
      </div>
    </div>
  );
};

export default ContentCardResults;
export type { ContentCardResultsProps };
